import { useContext } from "react";

import LocaleContext from "../LocaleContext";
import { TLocaleContext } from "../types";

const useLocales = (): TLocaleContext => useContext(LocaleContext);

export default useLocales;
